import styled from 'styled-components';
import { color, space, textAlign } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { ThemeInterface } from '../theme/ThemeInterface';

type Props = StyledSystemProps & {
  pointer?: boolean;
};

const BodyText = styled.p<Props>`
  ${space};
  ${color};
  ${textAlign};
  font-size: ${(props: ThemeInterface) => props.theme.fontSize[0]};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
  &:hover {
    cursor: ${(props: ThemeInterface) => (props.pointer ? 'pointer' : 'default')};
  }
`;

export default BodyText;
